module.exports = __webpack_public_path__ + "img/iforce.bce500df.jpg";